import papa from 'papaparse';

/**
 * Encodes labels as one comma-separated CSV record, escaping commas, quotes, and line breaks within labels.
 * Null, undefined, and empty labels are omitted. A file exporter must still quote this value as an outer CSV cell.
 */
export const serializeLabelsForCsv = (labels?: readonly (string | null | undefined)[] | null): string => {
    const nonEmptyLabels = (labels ?? []).filter((label): label is string => Boolean(label));
    const labelsCell = papa.unparse([nonEmptyLabels], { delimiter: ',' });
    return labelsCell;
};

/**
 * Reads quoted or plain comma-separated labels, trimming each label and removing empty entries.
 * Malformed or multi-record input uses legacy comma splitting. Label order and duplicates are preserved.
 */
export const parseLabelsFromCsv = (value?: string | null): string[] => {
    const labelsCell = value?.trim() ?? '';
    const parsed = papa.parse<string[]>(labelsCell, { delimiter: ',' });
    // Preserve the previous behavior for legacy cells that are not a valid single CSV record.
    const labels = parsed.errors.length === 0 && parsed.data.length === 1 ? parsed.data[0] : labelsCell.split(',');
    const nonEmptyLabels = labels.map((label) => label.trim()).filter(Boolean);
    return nonEmptyLabels;
};
